import React, { useEffect } from "react";
// Librerías
import styled from "styled-components";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
// Components
import Presentacion from "../components/inicio/presentacion";
import Introduccion from "../components/inicio/introduccion";
import Estrellas from "../components/inicio/estrellas";
import Seguros from "../components/inicio/seguros";
import Pasos from "../components/inicio/pasos";
import Referidos from "../components/inicio/referidos";
import Beneficios from "../components/inicio/beneficios";
import Contacto from "../components/inicio/contacto";
import Faqs from "../components/inicio/faqs";
import BotonFlotante from "../components/inicio/boton-flotante";
import {useSEO} from "../hooks/useSEO";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;
  background-color: var(--blanco);

  // Motion Div
  .motion-div {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: row;
  }
`;

export default function InicioPage() {
  const location = useLocation();

  useSEO({
    title: "",
    description:
      "¡Cotizá online y ahorrá! Coberturas para auto, moto, hogar, camión, bici y más con asesoría personalizada. Encontrá todos los seguros en un solo lugar.",
    path: "/",
  });

  // Scroll al hash o al inicio de la página
  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    } else {
      //document.documentElement.scrollTop = 0;
    }
  }, [location]);

  return (
    <Container>

      {/* Boton Flotante WhatsApp*/}
      <BotonFlotante />

      <motion.div
        className="motion-div"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 1, transition: { duration: 0.3 } }}
      >
        {/* Presentacion */}
        <Presentacion></Presentacion>
        {/* Introduccion */}
        <Introduccion></Introduccion>
        {/* Seguros */}
        <Seguros></Seguros>
        {/* Pasos */}
        <Pasos></Pasos>
        {/* Referidos */}
        <Referidos></Referidos>
        {/* Beneficios */}
        {/* <Beneficios></Beneficios> */}
        <Faqs></Faqs>
        {/* Contacto */}
        <Contacto></Contacto>
        {/* Faqs */}
      </motion.div>
    </Container>
  );
}
